export default () => ({
  isLoading: false,
  isLoaded: false,

  original: null,
  modified: null
})
